import { Action, createReducer, on } from '@ngrx/store';
import * as ConfigActions from '../actions/config.actions';
import { Theme } from '../../../core/models/theme.model';
export const configFeatureKey = 'config';

export interface State {
  theme: Theme;
  amStatus: [];
}

export const initialState: State = {
  theme: null,
  amStatus: null,
};

export const reducer = createReducer(
  initialState,

  on(ConfigActions.loadConfig, (state) => state),
  on(ConfigActions.loadConfigSuccess, (state, { theme }) => ({
    ...state,
    theme,
  })),
  on(ConfigActions.updateConfig, (state, { theme }) => ({ ...state, theme })),
  on(ConfigActions.loadWFStatusSuccess, (state, { states }) => ({
    ...state,
    amStatus: states,
  }))
);
